import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, LineChart, Line, ResponsiveContainer } from 'recharts';
import { format, parseISO, startOfMonth, endOfMonth } from 'date-fns';
import Charts from './Charts';
import { useEffect, useState } from 'react';
import { getFromServer } from '../../../components/Common/requests';
import useGetFromServer from '../../../utils/useGetFromServer';

const ChartsVisits = () => {
  const [queryDate, setQueryDate] = useState([
    {
      startDate: startOfMonth(new Date()),
      endDate: endOfMonth(new Date()),
      key: 'selection'
    }
  ])
  const groupDataByInterval = (data, interval) => {
    return data.reduce((acc, { date, visits }) => {
      let key;
      if (interval === 'day') {
        key = format(parseISO(date), 'dd MMM yyyy'); // Group by day
      } else if (interval === 'month') {
        key = format(parseISO(date), 'MMM yyyy'); // Group by month
      } else if (interval === 'year') {
        key = format(parseISO(date), 'yyyy'); // Group by year
      } else {
        throw new Error('Unsupported interval'); // Handle unsupported intervals
      }

      const existingItem = acc.find(item => item.period === key);
      if (existingItem) {
        existingItem.totalVisits += visits;
      } else {
        acc.push({
          period: key,
          totalVisits: visits
        });
      }

      return acc;
    }, []);
  };

  const renderChart = (chartType, groupedData) => {
    switch (chartType) {
      case 'PieChart':
        return (
          <PieChart width={400} height={400}>
            <Pie
              dataKey="value"
              isAnimationActive={false}
              data={groupedData.map((item) => ({ name: item.period, value: item.totalVisits }))}
              cx={200}
              cy={200}
              outerRadius={150}
              fill="#55d8b0"
              label
            >
              {groupedData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={`#${Math.floor(Math.random() * 16777215).toString(16)}`} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        );
      case 'BarChart':
        return (
          <ResponsiveContainer width={'100%'} height={400}>
            <BarChart width={400} height={400} data={groupedData} barCategoryGap={5}>
              <XAxis dataKey="period" axisLine={false} tickLine={false} />
              <YAxis axisLine={false} tickLine={false} />
              <Tooltip />
              <Legend />
              <Bar dataKey="totalVisits" fill="#55d8b0" radius={5} />
            </BarChart>
          </ResponsiveContainer>
        );
      case 'LineChart':
        return (
          <ResponsiveContainer width={'100%'} height={400}>
            <LineChart width={400} height={400} data={groupedData}>
              <XAxis dataKey="period" axisLine={false} tickLine={false} />
              <YAxis axisLine={false} tickLine={false} />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="totalVisits" stroke="#55d8b0" />
            </LineChart>
          </ResponsiveContainer>
        );
      default:
        return null;
    }
  };

  const getDate = (date) => {
    setQueryDate(date)
  }

  const getParam = () => {
    const { startDate, endDate } = queryDate[0]

    format(endDate, 'yyyy-MM-dd')
    return new URLSearchParams({
      startDate: format(startDate, 'yyyy-MM-dd'),
      endDate: format(endDate, 'yyyy-MM-dd'),
    });
  }

  const params = getParam()
  const { data, loading } = useGetFromServer(`dashboard-visits?${params}`, [queryDate])

  return (
    <Charts data={data}
      groupDataByInterval={groupDataByInterval}
      renderChart={renderChart}
      title={'Advance Visit'}
      groupBy={'day'}
      getDate={getDate}
      isLoading={loading}
    />
  );
};

export default ChartsVisits;
